import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { Observable } from 'rxjs';
import { CaptainDAO } from '../../../../../../../core/services/dao/captainDAO';
import { MatOptionSelectionChange } from '@angular/material/core';
import { map, startWith } from 'rxjs/operators';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { ContainsSubscriptions } from '../../../../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { VesselDAO } from '../../../../../../../core/services/dao/vesselDAO';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-captain-information',
  templateUrl: './captain-information.component.html',
  styleUrls: ['./captain-information.component.scss'],
})
export class CaptainInformationComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input()
  selectedCaptainsIds: number[];

  @Input()
  model: Vessel;

  @Input() canSave: boolean;

  @Input() isAdmin: boolean;

  @Output() setCaptainsChanged = new EventEmitter<number[]>();

  captainForm: FormGroup;
  filteredCaptains: Observable<Captain[]>;
  preferredCaptains: Captain[];
  captains: Captain[];
  primaryCaptainId: number;
  subs: Subscription[] = [];
  modelSaving: boolean;

  constructor(
    private captainDao: CaptainDAO,
    private vesselDAO: VesselDAO,
    private snackBar: MatSnackBar,
    public router: Router,
  ) {}

  ngOnInit() {
    this.captainForm = new FormGroup({
      captain: new FormControl('', []),
    });
    this.captainDao
      .loadCaptainsByIds(this.selectedCaptainsIds)
      .subscribe((preferred) => {
        this.preferredCaptains = preferred;
      });

    this.captainDao.loadActiveCaptains().subscribe((activeCaptains) => {
      this.captains = activeCaptains;
      this.filteredCaptains =
        this.captainForm.controls.captain.valueChanges.pipe(
          startWith(''),
          map((name) => this.filterCaptains(name)),
        );
    });
  }

  ngOnDestroy() {}

  filterCaptains(val: string): Captain[] {
    return this.captains.filter((s) =>
      new RegExp(val, 'gi').test(s.user.firstName + ' ' + s.user.lastName),
    );
  }

  selectCaptain($event: MatOptionSelectionChange, captain: Captain) {
    if (!this.preferredCaptains.find((cap) => cap.id === captain.id)) {
      this.captainForm.controls.captain.setValue('');
      if (this.preferredCaptains.length === 0) {
        this.model.primaryCaptainId = captain.id;
      }
      this.preferredCaptains.push(captain);
      this.setCaptainsChanged.emit(
        this.preferredCaptains.map((capt) => capt.id),
      );
    }
  }

  syncCaptainsList(): void {
    this.modelSaving = true;

    const primarySub = this.vesselDAO
      .updateFromPartial(this.model.id, {
        primaryCaptainId: this.model.primaryCaptainId,
      })
      .subscribe((data) => {
        const captainSub = this.vesselDAO
          .updateVesselCaptains(
            this.model.id,
            this.preferredCaptains.map((capt) => capt.id),
          )
          .subscribe(() => {
            this.modelSaving = false;
            this.openSnackbar('Vessel Captain Information Saved');
          });
        this.subs.push(captainSub);
      });
    this.subs.push(primarySub);
  }

  removeCaptain(captain: Captain) {
    const captainToRemoveIndex = this.preferredCaptains.findIndex(
      (cap) => cap.id === captain.id,
    );
    if (captainToRemoveIndex > -1) {
      this.preferredCaptains.splice(captainToRemoveIndex, 1);
      this.setCaptainsChanged.emit(
        this.preferredCaptains.map((capt) => capt.id),
      );
    }
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
